import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { SBAMultiSelectCheck, SBAComboBox, SBAAutoComplete } from "../../UiComponents/SBADropDown";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { AgGridReact } from 'ag-grid-react';
import { sbaAxios } from "../../utils/sbaAxios";
import { GetDynamicListInvestors, deleteEmailTemplate, emailMarketingTestSentAPI, getAllContactListAPI, getContactByContactListAPI,getEmailDocuByTemplateIdAPI, getContactListByTypeTextAPI, getEmailIdListAPI, getEmailTemplateListAPI, getSelectedEmailTemplateAPI, updateEmailTemplateAPI, getRecipientsDataByContactId, emailMarketingSendAPI } from "../../../config/apiConfig";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { useSelector } from "react-redux";
import { Accordion, Form } from "react-bootstrap";
const addItem = {
    "TemplateId": 0,
    "TemplateName": "",
    "Description": "",
    "From": "",
    "CC": "",
    "BCC": "",
    "Subject": "",
    "Body": "",
    "BodyHtml": "",
    "UserId": 0,
    "SourceType": null,
    "AttachmentsDetails": null,
    "RecipientDetails": null,
    "TrackOpening": false,
    "TrackLink": false,
    "SendOneCopy": false,
    "DeleteAttachmentIds": null,
    "ToDetails": null,
    "CCDetails": null,
    "BCCDetails": null,
    "TOIdList": null,
    "TOMailList": null,
    "ModifiedDate": "",
    "SelectedListIds": null
};
export const EmailMarketings = () => {
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [templateList, setTemplateList] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [showRecipientsDrawer, setShowRecipientDrawer] = useState(false);
    const [selectedRecipient, setSelectedRecipient] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showTestSendPreviewModal, setShowTestSendPreviewModal] = useState(false);
    const [showSendPreviewModal, setShowSendPreviewModal] = useState(false);
    const [selectedList,setSelectedList]=useState([]);
    const [render, setRender] = useState(false);
    const isInitialLoad = useRef(true);
    const gridRef=useRef(null);


    const getEmailTemplateList = async () => {
        try {
            const response = await sbaAxios({ url: getEmailTemplateListAPI });
            return response;
        } catch (error) {
            return [];
        }
    };
    const getEmailTemplateById = async (id) => {
        try {
            const response = await sbaAxios({ url: getSelectedEmailTemplateAPI+''+id });
            return response;
        } catch (error) {
            return [];
        }
    };
    const getEmailList = async () => {
        try {
            const response = await sbaAxios({ url: getEmailIdListAPI });
            return response;
        } catch (error) {
            return [];
        }
    };
    const fetchData = async () => {
        const templateList = await getEmailTemplateList();
        const emailList = await getEmailList();
        setTemplateList(val => templateList);
        setEmailList(val => emailList)
    };
    useEffect(() => {
        if (!isInitialLoad.current) {
            LoadGrid();
            setSelectedEmail(val => null);
        }
    }, [render]);
    useEffect(() => {
        if (isInitialLoad.current) {
            fetchData();
            isInitialLoad.current = false;
        }
    }, []);

    const LoadGrid = async () => {
        const templateList = await getEmailTemplateList();
        setTemplateList(val => templateList);

    };
    // deleteEmailTemplate
    const DeleteEmailMarketingModal = () => {
        setShowDeleteModal(true);
    };
    const deleteSelectedEmailMarketing = async () => {
        try {
            if (selectedEmail?.TemplateId) {
                const response =await sbaAxios({ url: deleteEmailTemplate + selectedEmail.TemplateId });
                setShowDeleteModal(false);
                SBNotify({ Msg: "Selected Email Template Deleted Successfully" });
                LoadGrid();
                setSelectedEmail(val => null);
            }
        } catch (error) {

        }
    }

    const ActionRenderer = (props) => {
        return <>
            <button
                style={{ border: "none", height: "0px" }}
                onClick={() => { DeleteEmailMarketingModal() }}
            >
                <i
                    className="fas fa-trash text-danger"
                ></i>
            </button>
        </>
    }
    const emailColDef = [
        { headerName: "Email Template", field: "TemplateName" },
        { headerName: "Description", field: "Description" },
        { headerName: "Action", field: "", floatingFilter: false, maxWidth: 200, cellRenderer: ActionRenderer }
    ];
    const addEmailMarketing = () => {
        setSelectedEmail(value => addItem);
    };
    const testSendEmail=(name, mailID)=>{
        if(!selectedEmail?.TemplateId>0)
        {
            SBNotify({Msg:"Please Select a Email Template",type:"error"});
            return 
        }
        // if(selectedRecipient.length<1)
        // {
        //     SBNotify({Msg:"Please Select any one Recipient",type:"error"});
        //     return 
        // }

            const emailTemplate= selectedEmail;
            const recipients= selectedRecipient;
    
            const fromMailId=emailTemplate.From.match(/<(.*?)>/)[1];
            const fromName=emailTemplate.From.match(/^(.*)</)[1].trim();
            const ccList= 
            // emailTemplate.CC.trim() !=="" ? emailTemplate.CC.split(',').map(item=>{
            //     const mailId=item.match(/<(.*?)>/)[1];
            //     const mailName=item.match(/^(.*)</)[1].trim();
            //     return {
            //         "Id": 1,
            //         "FullName": mailName,
            //         "MailAddress": mailId,
            //         "RecipientType": 3
            //     }
            // }):
            [];
            const bccList= 
            // emailTemplate.BCC.trim() !=="" ? emailTemplate.BCC.split(',').map(item=>{
            //     const mailId=item;
            //     const mailName=item;
            //     return {
            //         "Id": 1,
            //         "FullName": mailName,
            //         "MailAddress": mailId,
            //         "RecipientType": 4
            //     }
            // }) : 
            [];
            // const recipientList=recipients.map(item=>(
            //     {
            //         "Id": item.ContactId,
            //         "FullName": item.ContactName,
            //         "MailAddress":item.BusinessEmail,
            //         "RecipientType": 2
            //     }
            // ))
            const recipientList=[
                {
                    "Id": 1,
                    "FullName":name,
                    "MailAddress":mailID,
                    "RecipientType": 2
                }
            ];
    
            const PreparedData={
                "SourceType": "Newsletter",
                "TemplateId": emailTemplate.TemplateId,
                "TemplateName": emailTemplate.TemplateName,
                "Description": emailTemplate.Description,
                "From": [
                    {
                        "Id": 1,
                        "FullName": fromName,
                        "MailAddress": fromMailId,
                        "RecipientType": 1
                    }
                ],
                "CC": ccList,
                "BCC": bccList,
                "Subject": emailTemplate?.Subject || "",
                "Body": emailTemplate?.Body  || "",
                "BodyHtml": emailTemplate?.BodyHtml  || "",
                "RecipientDetails": recipientList,
                "TrackOpening":  false,
                "SendOneCopy": false,
                "SelectedListIds": "",
                "TrackLink":  false
            };
            sbaAxios({url:emailMarketingTestSentAPI, data:PreparedData , method:'post'}).then(res=>{
                if(res.MessageSent)
                SBNotify({Msg:"Mail Sent Successfully"});
                else {
                SBNotify({Msg:res.Error,type:"error"});
                }
            }).catch(()=>{
                SBNotify({Msg:"Some Exception Occured , Please Contact Admin",type:"error"});
            });
    };
    const openTestSendModal=()=>{
        if(!selectedEmail?.TemplateId>0)
        {
            SBNotify({Msg:"Please Select a Email Template",type:"error"});
            return 
        }
        setShowTestSendPreviewModal(true)
    };
    const openSendModal=()=>{
        if(!selectedEmail?.TemplateId>0)
        {
            SBNotify({Msg:"Please Select a Email Template",type:"error"});
            return 
        }
        setShowSendPreviewModal(true)
    };
    const setSelectedEmailById=async(id)=>{
        try {
            const response=await getEmailTemplateById(id);
            setSelectedEmail(response[0]);
        } catch (error) {
            setSelectedEmail(null);
        }
    };
    const sendMail=()=>{
            if(!selectedEmail?.TemplateId>0)
            {
                SBNotify({Msg:"Please Select a Email Template",type:"error"});
                return;
            }
            if(selectedRecipient.length<1)
            {
                SBNotify({Msg:"Please Select any one Recipient",type:"error"});
                return;
            }
    
                const emailTemplate= selectedEmail;
                const recipients= selectedRecipient;
        
                const fromMailId=emailTemplate.From.match(/<(.*?)>/)[1];
                const fromName=emailTemplate.From.match(/^(.*)</)[1].trim();
                const ccList= emailTemplate.CC.trim() !=="" ? emailTemplate.CC.split(',').map(item=>{
                    const mailId=item.match(/<(.*?)>/)[1];
                    const mailName=item.match(/^(.*)</)[1].trim();
                    return {
                        "id": 1,
                        "fullName": mailName,
                        "mailAddress": mailId,
                        "recipientType": 3
                    }
                }) : [];
                const bccList= emailTemplate.BCC.trim() !=="" ? emailTemplate.BCC.split(',').map(item=>{
                    const mailId=item;
                    const mailName=item;
                    return {
                        "id": 1,
                        "fullName": mailName,
                        "mailAddress": mailId,
                        "recipientType": 4
                    }
                }) : [];
                const recipientList=recipients.map(item=>(
                    {
                        "id": item.ContactId,
                        "fullName": item.ContactName,
                        "mailAddress":item.BusinessEmail,
                        "recipientType": 2
                    }
                ));
                const fromMail=  [
                    {
                        "id": 1,
                        "fullName": fromName,
                        "mailAddress": fromMailId,
                        "recipientType": 1
                    }
                ];
                const formattedData={
                    "templateId": emailTemplate.TemplateId,
                    "templateName": emailTemplate.TemplateName,
                    "description": emailTemplate.Description,
                    "from": fromMailId,
                    "cc": "",
                    "bcc": "",
                    "subject": "",
                    "body": "",
                    "bodyHtml": "",
                    "userId": 0 ,
                    "sourceType": "send",
                    "attachmentsDetails": [],
                    "recipientDetails": [ 
                        ...ccList,...bccList,...recipientList
                    ],
                    "trackOpening": false,
                    "trackLink": false,
                    "sendOneCopy": false,
                    "deleteAttachmentIds": "",
                    "toDetails": [],
                    "ccDetails": [],
                    "bccDetails": [],
                    "toIdList": "",
                    "toMailList": "",
                    "modifiedDate": new Date().toISOString(),
                    "selectedListIds": selectedList?.map(item=>item.ContactListId).join(',') || "",
                  };
                sbaAxios({url:emailMarketingSendAPI , data:formattedData , method:'post'}).then(res=>{
                    SBNotify({Msg:"Mail Sent Successfully"});
                    setRender(val=>!val);
                    setShowSendPreviewModal(false);
                }).catch(()=>{
                    SBNotify({Msg:"Some Exception Occured , Please Contact Admin",type:"error"});
                });
    };
    const updateTemplateSelection = async (val) => {
        try {
            await LoadGrid();
            await setSelectedEmailById(val);
    
            gridRef.current.api.forEachNode((node) => {
                if (node.data.TemplateId === val) {
                    node.setSelected(true);
                } else {
                    node.setSelected(false);
                }
            });
        } catch (error) {
            console.error("Error updating template selection:", error);
        }
    };
    return (
        <div id="emailMarketing">
            <div className="container-fluid px-0">
                <div >
                    <div className="d-flex justify-content-end gap-2">
                        <button type="button" className="p-sm-btn mx-1" onClick={() => { openSendModal() }} >Send</button>
                        <button type="button" className="p-sm-btn mx-1 text-nowrap" onClick={() => { openTestSendModal() }} >Test Send</button>
                        <button type="button" className="p-sm-btn mx-1" onClick={() => { addEmailMarketing() }}><i className="fa-solid fa-plus" /> Add</button>
                        <button type="button" className="p-sm-btn mx-1" disabled={!selectedEmail} onClick={() => { setShowRecipientDrawer(true); setSelectedRecipient([]);setSelectedList([]); }}>Recipients</button>
                    </div>
                </div>
                <div className="accordionContainer mt-3">
                    <Accordion defaultActiveKey="0" >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header></Accordion.Header>
                            <Accordion.Body className="bg-white h-100">
                                <div className="ag-theme-alpine" style={{ width: '100%' ,height: '400px' }}>
                                    <AgGridReact
                                        columnDefs={emailColDef}
                                        defaultColDef={{ flex: 1, floatingFilter: true, filter: "agTextColumnFilter",resizable:true }}
                                        rowData={templateList}
                                        rowSelection="single"
                                        onRowClicked={(e) => setSelectedEmailById(e.data.TemplateId)}
                                        ref={gridRef}
                                    />
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
            {selectedEmail && <SelectedEmailSection  selectedList={selectedList} getUpdatedTemplate={updateTemplateSelection} setRender={setRender} selectedRecipient={selectedRecipient} emailDetail={selectedEmail} setEmailDetail={setSelectedEmail} emailList={emailList} />}
            <SBADrawer title="Choose Recipients" open={showRecipientsDrawer} setOpen={setShowRecipientDrawer} size='lg'>
                <RecipientEditor setRecipient={setSelectedRecipient} setSelectedList={setSelectedList} setDrawer={setShowRecipientDrawer} ></RecipientEditor>
            </SBADrawer>
            <Modal show={showDeleteModal}>
                <Modal.Header
                    closeButton

                >
                    <Modal.Title>
                        Deleted Selected Email Template
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedEmail?.TemplateName}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="s-sm-btn mx-1"
                        onClick={() => {
                            setShowDeleteModal(false);
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="p-sm-btn mx-1" onClick={() => { deleteSelectedEmailMarketing() }}
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
            { showTestSendPreviewModal &&  <TestSendPreviewModal showModal={showTestSendPreviewModal} setShowModal={setShowTestSendPreviewModal} testSendEmail={(name,mailId)=>{testSendEmail(name,mailId)}}></TestSendPreviewModal>}
            { showSendPreviewModal &&  <SendPreviewModal showModal={showSendPreviewModal} setShowModal={setShowSendPreviewModal} sendMail={()=>{sendMail()}} ></SendPreviewModal>}
        </div>
    );
};
const SendPreviewModal=({showModal,setShowModal,sendMail})=>{
    return  <Modal show={showModal} >
    <Modal.Header
        closeButton
        onHide={()=>{setShowModal(false)}}
    >
        <Modal.Title >
        Send Email
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
    Are you sure you want to send out the emails now?
    </Modal.Body>
    <Modal.Footer>
        <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowModal(false);
            }}
        >
            Cancel
        </button>
        <button className="p-sm-btn mx-1" onClick={() => { sendMail() }}>
            Ok
        </button>
    </Modal.Footer>
</Modal>
}
const RecipientEditor = ({ setDrawer, setRecipient ,setSelectedList }) => {
    const [availableRecipient, setAvaliableRecipient] = useState([]);
    const [selectedRecipient, setSelectedRecipient] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [selectedContactList, setSelectedContactList] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [selectedListContacts, setSelectedListContact] = useState([]);
    const selectedContactRef = useRef();
    const availableContactRef = useRef();
    useEffect(() => {
        getContactList();
    }, []);
    const getAvaialableContacts = async (listId, typeId) => {
        try {
            const response = await sbaAxios({ url: `${getContactByContactListAPI}/${listId}/${typeId}` })
            return response;
        } catch (error) {
            return [];
        }
    };
    const selectContactColDef = [
        { headerName: "Available Recipients", field: "ContactName" },
        { headerName: "Email", field: "BusinessEmail" }
    ];
    const availableContactColDef = [
        { headerName: "Available Recipients", field: "ContactName" },
        { headerName: "Email", field: "BusinessEmail" },
    ];
    const addRecipient = (data) => {
        if ([...selectedListContacts,...selectedContacts].findIndex(item => item?.ContactId == data?.ContactId) == -1) {
            setSelectedContacts(val => [...val, data])
        }
    };
    const removeRecipient = (rowData) => {
        setSelectedContacts(val => [...val.filter(item => (item.ContactId !== rowData.ContactId))]);
        setSelectedListContact(val => [...val.filter(item => (item.ContactId !== rowData.ContactId))]);
    };
    const getAvailableRecipient = async (value) => {
        try {
            const response = await sbaAxios({ url: `${getContactListByTypeTextAPI}?searchText=${value}&typeId=1` });
            setAvaliableRecipient(response);
            return response;
        } catch (error) {
            return [];
        }
    };
    const getAvailableRecipientInSelectedList = async (e) => {
        try {
            if (e.value) {
                setSelectedContactList(e.value);
                getContactListForGrid(e.value);
            }
        } catch (error) {
            setSelectedListContact([]);
        }
    };
    const getContactListForGrid = (value) => {
        try {
            if (value.length > 0)
                value.map(async item => {
                    const additionalContacts = await getAvaialableContacts(item.ContactListId, item.ContactListTypeId);
                    setSelectedListContact(val => [...val, ...additionalContacts]);
                });
            else
                setSelectedListContact([]);
        } catch (error) {

        }
    }
    const addContact = () => {
        const selectedRow = availableContactRef?.current?.api?.getSelectedRows()[0];
        selectedRow && addRecipient(selectedRow);
    };
    const removeContact = () => {
        const selectedRow = selectedContactRef?.current?.api?.getSelectedRows()[0];
        selectedRow && removeRecipient(selectedRow);
    };
    const getContactList = async () => {
        try {
            const response = await sbaAxios({ url: getAllContactListAPI });
            setContactList(response)
        } catch (error) {

        }
    };
    return <>
        <div>
            <label className="label">Contact List Name</label>
            <div>
                < SBAMultiSelectCheck
                    className='w-50'
                    onChange={(e) => { getAvailableRecipientInSelectedList(e) }}
                    value={selectedContactList}
                    popupSettings={{ className: 'modalDD' }}
                    data={contactList}
                    textField="ContactListName"
                    valueField="ContactListId"
                    tags={selectedContactList.length > 0 ? [{
                        text: `${selectedContactList.length} items selected`,
                        data: [...selectedContactList],
                    }] : []}
                />
            </div>
        </div>
        <div>
            <label className="label">Search Contact</label>  <SBAAutoComplete className="w-50" onChange={(e) => { getAvailableRecipient(e.value) }} ></SBAAutoComplete>
        </div>
        <div className="d-flex gap-2">
            <div className="ag-theme-alpine" style={{ width: '45%', height: '50vh' }}>
                <AgGridReact
                    ref={availableContactRef}
                    columnDefs={availableContactColDef}
                    defaultColDef={{ flex: 1, floatingFilter: true, filter: "agTextColumnFilter",resizable:true }}
                    rowData={availableRecipient}
                    rowSelection="single"
                    onRowDoubleClicked={(e) => { addRecipient(e.data) }}
                />
            </div>
            <div className="d-flex flex-column gap-2 justify-content-center" style={{ width: '10%' }}>
                <button className="p-sm-btn" onClick={() => { addContact() }}><i class="fa-solid fa-arrow-right"></i></button>
                <button className="p-sm-btn" onClick={() => { removeContact() }}> <i class="fa-solid fa-arrow-left"></i></button>
            </div>
            <div className="ag-theme-alpine" style={{ width: '45%', height: '50vh' }}>
                <AgGridReact
                    ref={selectedContactRef}
                    columnDefs={selectContactColDef}
                    defaultColDef={{ flex: 1, floatingFilter: true, filter: "agTextColumnFilter",resizable:true }}
                    rowData={[...selectedListContacts, ...selectedContacts]}
                    rowSelection="single"
                    onRowDoubleClicked={(e) => { removeRecipient(e.data) }}
                />
            </div>
        </div>
        <div className="d-flex justify-content-end mx-2 my-4 gap-3">
            <button className="s-sm-btn" onClick={() => { setDrawer(false) }}>Cancel</button>
            <button className="p-sm-btn" onClick={() => { setRecipient([...selectedContacts, ...selectedListContacts]); setSelectedList([...selectedContactList]); setDrawer(false) }}>Add</button>
        </div>
    </>
};
const SelectedEmailSection = ({ emailDetail,setEmailDetail,getUpdatedTemplate, selectedRecipient, emailList, selectedList }) => {
    const [emailContent, setEmailContent] = useState('<></>');
    const [emailData, setEmailData] = useState(emailDetail);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [emailAttachment,setEmailAttachment]=useState(emailDetail?.AttachmentsDetails?.map((item,index)=>({
        "index":index,
        "documentContentID": item.DocumentContentID,
        "documentContent": item.DocumentContent,
        "documentSize": item.DocumentSize,
        "documentTypeId": item.DocumentTypeId,
        "documentCheckSum": item.DocumentCheckSum,
        "documentName": item.DocumentName,
        "description": item.Description,
        "extension": item.Extension,
        "dateCreated": item.DateCreated,
        "documentExpiryDate": item.DocumentExpiryDate,
        "documentAttributeIds": "",
        "mode":'Existing',
        "attachmentId":item.AttachmentId
    })) || []);
    useEffect(() => {
        setEmailData(emailDetail);
        setEmailContent(emailDetail.BodyHtml);
        setEmailAttachment(emailDetail?.AttachmentsDetails?.map((item,index)=>({
            "index":index,
            "documentContentID": item.DocumentContentID,
            "documentContent": item.DocumentContent,
            "documentSize": item.DocumentSize,
            "documentTypeId": item.DocumentTypeId,
            "documentCheckSum": item.DocumentCheckSum,
            "documentName": item.DocumentName,
            "description": item.Description,
            "extension": item.Extension,
            "dateCreated": item.DateCreated,
            "documentExpiryDate": item.DocumentExpiryDate,
            "documentAttributeIds": "",
            "mode":'Existing',
            "attachmentId":item.AttachmentId
        })) || [])
    }, [emailDetail]);
    
    const ccText = emailData?.CC?.split(',');
    const bccText = emailData?.BCC?.split(',');
    const selectedCC = emailList.filter(item => (ccText.some(data => (data.replace(/'/g, '') === item.EmailAddress.replace(/'/g, ''))))) || [];
    const selectedBCC = emailList.filter(item => (bccText.some(data => (data.replace(/'/g, '') === item.EmailName.replace(/'/g, ''))))) || [];
    const selectedFrom = emailList.filter(item => (emailData?.From?.replace(/'/g, '') === item.EmailAddress.replace(/'/g, '')))[0];
    const updateCC = (e) => {
        if (e.value) {
            const updatedString = e.value.map(item => item.EmailAddress).join(',');
            setEmailData(value => ({ ...value, CC: updatedString }));
        }
    };
    const updateBcc = (e) => {
        if (e.value) {
            const updatedString = e.value.map(item => item.EmailName).join(',');
            setEmailData(value => ({ ...value, BCC: updatedString }));
        }
    };
    const updateFrom = (e) => {
        if (e.value) {
            const updatedString = e.value.EmailAddress;
            setEmailData(value => ({ ...value, From: updatedString }));
        }
    };
    const updateEmailDetails = (key, value) => {
        setEmailData(val => ({ ...val, [key]: value }))
    };
    const updateTemplate = async() => {
        const attachmentInfo=emailData?.AttachmentsDetails?.map(item=>({
            "attachmentId":item.attachmentId || 0,
            "documentContentID": item.documentContentID || 0,
            "documentContent": item.documentContent || '',
            "documentSize": parseInt(item.documentSize) || 0,
            "documentTypeId": 0,
            "documentCheckSum": "",
            "documentName": item.documentName || "",
            "description": item.description || "",
            "extension": item.extension || "",
            "dateCreated": new Date().toISOString(),
            "documentExpiryDate": new Date().toISOString(),
            "documentAttributeIds": "",
            "mode":item.mode || ""
          })).filter(item=>item.mode!=="Existing") || [];
        const saveData = {
            "templateId": emailData.TemplateId,
            "templateName": emailData.TemplateName,
            "description": emailData.Description,
            "from": emailData.From,
            "cc": emailData.CC,
            "bcc": emailData.BCC,
            "subject": emailData.Subject,
            "body": emailData.Body,
            "bodyHTML": emailData.BodyHtml,
            "userId": 0,
            "trackOpening": emailData.TrackOpening,
            "trackLink": emailData.TrackLink,
            "sendOneCopy": emailData.SendOneCopy,
            "attachmentsDetails": attachmentInfo,
        };
        if (!saveData.templateName) {
            SBNotify({ Msg: "Please Enter the Template Name", type: 'error' });
            return;
        }
        if (!saveData.description) {
            SBNotify({ Msg: "Please Enter the description", type: 'error' });
            return;
        }
        if (!saveData.from) {
            SBNotify({ Msg: "Please Select the From Email", type: 'error' });
            return;
        }
        if (!saveData.templateName) {
            SBNotify({ Msg: "Please Enter the Template Name", type: 'error' });
            return;
        }
        if (!saveData.subject) {
            SBNotify({ Msg: "Please Enter the Subject", type: 'error' });
            return;
        }

       await sbaAxios({ url: updateEmailTemplateAPI, method: 'post', data: saveData }).then(res => {
            if(res===-1)
            {
                SBNotify({ Msg: "Template Name Already Exists" ,type:'error' });
                return;
            }

            if (saveData.templateId === 0)
            {
                SBNotify({ Msg: "Selected Email Template Created Successfully" });
                getUpdatedTemplate(res);
            }
            else
            {
                SBNotify({ Msg: "Selected Email Template Updated Successfully" });
                getUpdatedTemplate(res);
            }
        });
       
    };
    const deleteSelectedAttachment=(e)=>{
        const itemTORemove=e.data.index;
        const updatedAttachment=emailAttachment.map(item=>({...item,mode:item.index===itemTORemove ? 'Delete' : item.mode})) 
        setEmailAttachment(updatedAttachment);
        setEmailData(val=>({...val,AttachmentsDetails:updatedAttachment}));
    }
    const RemoveAttachment=(e)=>{
        return  <>
         <button
                style={{ border: "none", height: "0px" }}
                onClick={() => { deleteSelectedAttachment(e) }}
            >
                <i
                    className="fas fa-trash text-danger"
                ></i>
            </button>
        </>
    }
    const attachmentColdef=[
        {headerName:'FileName', field:'documentName' , onCellClicked:(e)=>{ 
        if(e.data.mode=="Insert")
        {
            const fileName = e.data.documentName;
            const pdfData = e.data.documentContent;
            const byteCharacters = atob(pdfData);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const newTab = window.open();
            if (newTab) {
                newTab.document.write(`
                    <html>
                    <head>
                        <title>${fileName}</title>
                    </head>
                    <body>
                        <embed src="${url}" type="application/pdf" width="100%" height="100%"  name="embedded-pdf"/>
                    </body>
                    </html>
                `);
                newTab.document.close();
            }
        }
        else {
         const attachmentId=e?.data?.attachmentId;
            sbaAxios({
            url: getEmailDocuByTemplateIdAPI + attachmentId,
            responseType:"blob",
       }).then((response) => {
           const blobUrl = URL.createObjectURL(response);
           const newWindow = window.open(blobUrl, '_blank');
           URL.revokeObjectURL(blobUrl);
        });
        }
    }},
        {headerName:'Action', cellRenderer:RemoveAttachment , flex:0.5},
    ];
    const handleFileChange = (event) => {
        const files = event.target.files;
        let existingCount = emailAttachment.length;
    
        const ExistingData = emailAttachment.map((file, index) => ({
            attachmentId:file.attachmentId,
            index: index,
            documentContentID: file.documentContentID,
            documentContent: file.documentContent,
            documentSize: file.documentSize,
            documentTypeId: file.documentTypeId,
            documentCheckSum: file.documentCheckSum,
            documentName: file.documentName,
            description: file.description,
            extension: file.extension,
            dateCreated: file.dateCreated,
            documentExpiryDate: file.documentExpiryDate,
            documentAttributeIds: "",
            mode:file.mode,
            
        }));
    
        const newFiles = [];
    
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileName = file.name;
            const lastDotIndex = fileName.lastIndexOf('.');
            const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
            
            const reader = new FileReader();
            
            reader.onload = function () {
                if (reader.result) {
                    const arrayBuffer = reader.result;
                    const base64String = arrayBufferToBase64(arrayBuffer);
    
                    const formattedDocuData = {
                        attachmentId:0,
                        index: existingCount + i,
                        documentContentID: 0,
                        documentContent: base64String,
                        documentSize: (file.size / 1024).toFixed(2),
                        documentTypeId: file.documentTypeId,
                        documentCheckSum: file.documentCheckSum, 
                        documentName: file.name,
                        description: '', 
                        extension: extension,
                        dateCreated: file.dateCreated, 
                        documentExpiryDate: file.documentExpiryDate, 
                        documentAttributeIds: "" ,
                        mode:"Insert"
                    };
    
                    newFiles.push(formattedDocuData);
                    
                    if (newFiles.length === files.length) {
                        const updatedFileList = [...ExistingData, ...newFiles];
                        setEmailAttachment(updatedFileList);
                        setEmailData(val => ({ ...val, AttachmentsDetails: updatedFileList }));
                    }
                }
            };
            
            reader.readAsArrayBuffer(file);
        }
    };
    
    return <>
        <div className="mt-3 p-3 border rounded">
            <div className="row">
                <div className="col-md-2">
                    {/* <label>Selected Lists: <span>Not Selected</span></label> */}
                </div>
                <div className="col-md-10 d-flex gap-3 justify-content-end ">
                    <label>
                        <input type="checkbox" checked={emailData.SendOneCopy} onChange={(e) => { updateEmailDetails('SendOneCopy', e.target.checked) }} /> Copy First Recipient Only
                    </label>
                    {/* 
                    <label>
                        <input type="checkbox" checked={emailData.TrackOpening}  disabled onChange={(e) => { updateEmailDetails('TrackOpening', e.target.checked) }} /> Track Opening
                    </label>

                    <label>
                        <input type="checkbox" checked={emailData.TrackLink} disabled  onChange={(e) => { updateEmailDetails('TrackLink', e.target.checked) }} /> Track Links
                    </label> */}
                </div>
                <div >
                    <label>Total Recipients: <span>{selectedRecipient.length}</span></label>
                </div>
                <div >
                    <label>selectedList: <span>{selectedList.map(item=>item.ContactListName).join(',')}</span></label>
                </div>
            </div>
            <div className="my-2 d-flex gap-2 justify-content-end">
                <button type="button" className="p-sm-btn mx-1" onClick={() => { setShowPreviewModal(true) }}>Preview</button>
                <button type="button" className="p-sm-btn mx-1" onClick={() => { updateTemplate() }}>{emailData.TemplateId === 0 ? 'Add' : 'Update'}</button>
            </div>
        </div>
        <div className="mt-3 p-3 border rounded">
            <div className="row" >
                <div className="col-md-6">
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            Name
                        </label>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="Type here"
                            value={emailData.TemplateName}
                            onChange={(e) => { updateEmailDetails('TemplateName', e.target.value) }}
                        />
                    </div>
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            Description
                        </label>
                        <input
                            className="w-100 input-default form-control"
                            type="text"
                            placeholder="Type here"
                            value={emailData.Description}
                            onChange={(e) => { updateEmailDetails('Description', e.target.value) }}
                        />
                    </div>

                    <div className="my-2" >
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            From
                        </label>
                        <div>
                            <SBAComboBox
                                className="w-100"
                                dataItemKey="EmailListId"
                                textField="EmailAddress"
                                value={selectedFrom}
                                filterable={true}
                                data={emailList}
                                placeholder="Please Select"
                                onChange={updateFrom}
                            />
                        </div>
                    </div>
                    <div className="my-2">
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            CC
                        </label>
                        <div>
                            <SBAMultiSelectCheck
                                className="w-100"
                                dataItemKey="EmailListId"
                                textField="EmailAddress"
                                value={selectedCC}
                                data={emailList}
                                filterable={true}
                                tags={selectedCC.length > 0 ? [{ text: `${selectedCC.length} items selected`, data: [...selectedCC] }] : []}
                                placeholder="Please Select"
                                clearButton={false}
                                onChange={updateCC}
                            />
                        </div>
                    </div>
                    <div className="my-2" >
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            BCC
                        </label>
                        <div>
                            <SBAMultiSelectCheck
                                className="w-100"
                                dataItemKey="EmailListId"
                                textField="EmailName"
                                value={selectedBCC}
                                data={emailList}
                                filterable={true}
                                tags={selectedBCC.length > 0 ? [{ text: `${selectedBCC.length} items selected`, data: [...selectedBCC] }] : []}
                                placeholder="Please Select"
                                onChange={updateBcc}
                            />
                        </div>
                    </div>
                    <div className="my-2" >
                        <div className="col-md-12">
                            <label className="mb-1 ms-2 fs-12 fw-semibold">
                                To Recipients
                            </label>
                            {/* <SBAMultiSelectCheck
                                data={selectedRecipient}
                                value={selectedRecipient}
                                textField={'ContactName'}
                                dataItemKey={'ContactId'}
                                filterable
                                tags={selectedRecipient.length > 0 ? [
                                    {
                                        text: `${selectedRecipient.length} items selected`,
                                        data: [...selectedRecipient],
                                    },
                                ] : []}
                            /> */}
                            <div class="" title={selectedRecipient.map(contact => contact.ContactName).join(',')}>
                                {selectedRecipient.map(contact => contact.ContactName).join(',')}
                            </div>
                        </div>
                    </div>
                    <div className="my-2" >
                        <div className="col-md-12">
                            <label className="mb-1 ms-2 fs-12 fw-semibold">
                                Subject
                            </label>
                            <input
                                className="w-100 input-default form-control"
                                type="text"
                                placeholder="Type here"
                                value={emailData?.Subject}
                                onChange={(e) => { updateEmailDetails('Subject', e.target.value) }}

                            />
                        </div>
                    </div>
                    <div className="my-2">
                        <div>
                            <input
                                type="file"
                                className="form-control w-50" 
                                onChange={(e)=>{handleFileChange(e)}}
                                multiple

                            />
                        </div>
                    </div>
                    <div className="my-2" >
                        <div className="ag-theme-alpine" style={{ width: '100%', height: '200px' }}>
                            <AgGridReact
                                rowData={emailAttachment.filter(item=>item.mode!=="Delete")}
                                columnDefs={attachmentColdef}
                                overlayNoRowsTemplate={`<span>No data Available</span>`}
                                defaultColDef={{flex:1,resizable:true}}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <label htmlFor="editor" className="mb-1 ms-2 fs-12 fw-semibold">
                        Description
                    </label>
                    <SBAEditor
                        showTagTool={true}
                        defaultContent={emailContent}
                        onChange={(e) => { setEmailContent(val => e.html); setEmailData(value => ({ ...value, BodyHtml: e.html })) }}
                        editorHeight={500}
                        setContent={setEmailContent}
                    />
                </div>
            </div>

        </div>
        <EmailPreview from={selectedFrom} showPreview={showPreviewModal} setShowPreview={setShowPreviewModal} recipient={selectedRecipient} emailDetail={emailData} />
    </>
};
const EmailPreview = ({ from, showPreview, setShowPreview, recipient, emailDetail }) => {
    const [currentRecipientDetail, setCurrentRecipientDetail] = useState({});
    const [currentContactId, setCurrentContactId] = useState(null);
    const [previewEmailContent, setPreviewEmailContent] = useState(emailDetail.BodyHtml);

    useEffect(() => {
        if (currentContactId) {
            const fetchRecipientData = async () => {
                try {
                    const response = await sbaAxios({ url: `${getRecipientsDataByContactId}/${currentContactId}` });
                    setCurrentRecipientDetail(response); 
                } catch (error) {
                    console.error('Error fetching recipient data:', error);
                }
            };
            fetchRecipientData();
        }
    }, [currentContactId]);

    useEffect(() => {
        if (Object.keys(currentRecipientDetail).length > 0) {
            const updatedEmailContent = replacePlaceholders(emailDetail.BodyHtml, currentRecipientDetail);
            setPreviewEmailContent(val =>updatedEmailContent);
        }
        else {
            setPreviewEmailContent(val=>emailDetail.BodyHtml);
        }
    }, [currentRecipientDetail, emailDetail.BodyHtml]);

    const handleRecipientChange = (contactId) => {
        setCurrentContactId(contactId);
    };

    const replacePlaceholders = (content, data) => {
        return content
            .replace(/&lt;First Name&gt;/g, data.FirstName || '')
            .replace(/&lt;Last Name&gt;/g, data.LastName || '')
            .replace(/&lt;Company Name&gt;/g, data.CompanyName || '')
            .replace(/&lt;Title&gt;/g, data.Title || '')
            .replace(/&lt;Salutation&gt;/g, data.Salutation || '')
            .replace(/&lt;Signature&gt;/g, from.BodyHtml || '');
    };
    return <>
        <Modal show={showPreview} size="xl">
            <Modal.Header >
                <Modal.Title>
                    Mail Content Preview
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                <RecipientNavigator items={recipient} onRecipientChange={handleRecipientChange}></RecipientNavigator>
                </div>
                {/* <div>
                    <label class="mb-1 ms-2 fs-12 fw-semibold w-75 text-truncate" title={emailDetail.CC} >CC :{emailDetail.CC}</label>
                </div>
                <div>
                    <label class="mb-1 ms-2 fs-12 fw-semibold  w-75 text-truncate" title={emailDetail.BCC}>BCC :{emailDetail.BCC}</label>
                </div> */}
                <div className="row">
                    <div className="col-12">
                        <div dangerouslySetInnerHTML={{ __html: previewEmailContent }}></div>
                    </div>
                </div>

                {/* {recipient.map(item=>{
                    return  <div  dangerouslySetInnerHTML={{ __html: emailDetail.BodyHtml }}></div>
                })} */}

            </Modal.Body>
            <Modal.Footer>
                <button
                    className="s-sm-btn mx-1"
                    onClick={() => {
                        setShowPreview(false);
                    }}
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    </>
}


    

const TestSendPreviewModal=({showModal,setShowModal,testSendEmail})=>{
    const userDetails=useSelector(state=>state?.common?.userDetails) || {};
    const [userINFO,setUserINFO]=useState(userDetails);
    useEffect(()=>{
        setUserINFO(userDetails);
    },[])
    const updateRecipientMailId=()=>{
        if(!isValidEmail(userINFO.Email))
        {
            SBNotify({Msg:"Please Enter A Valid Email Address", type:"error"});
            return ;
        }
        testSendEmail(userINFO.DisplayName,userINFO.Email);
        setShowModal(value=>false);
    };
    function isValidEmail(email) {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    }
    
    return <>
      <Modal show={showModal} >
                <Modal.Header
                    closeButton
                    onHide={()=>{setShowModal(false)}}
                >
                    <Modal.Title  as="h5">
                    Test Email Will be Sent to the below Email Address
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <label className="mb-1 ms-2 fs-12 fw-semibold">
                           Display Name
                        </label>
                        <input type="text" className="form-control" value={userINFO.DisplayName} onChange={(e)=>{
                        setUserINFO(value=>({...value,DisplayName:e.target.value}))
                    }} />
                        <label className="mb-1 ms-2 fs-12 fw-semibold">
                            Email Address
                        </label>
                    <input type="text" className="form-control" value={userINFO.Email} onChange={(e)=>{
                        setUserINFO(value=>({...value,Email:e.target.value}))
                    }} />
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="s-sm-btn mx-1"
                        onClick={() => {
                            setShowModal(false);
                        }}
                    >
                        Cancel
                    </button>
                    <button className="p-sm-btn mx-1" onClick={() => { updateRecipientMailId() }}>
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>
    </>
};
const arrayBufferToBase64 = (arrayBuffer) => {
    const binary = [];
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary.push(String.fromCharCode(bytes[i]));
    }
    return btoa(binary.join(''));
};
const RecipientNavigator = ({ items, onRecipientChange }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [prevButtonEnable, setprevButtonEnable] = useState(false);
    const [nextButtonEnable, setnextButtonEnable] = useState(true);

    useEffect(() => {
        const currentRecipient = items[currentIndex];
        if (currentRecipient && currentRecipient.ContactId) {
            onRecipientChange(currentRecipient.ContactId);
        }
        // Update button states based on the current index
        setprevButtonEnable(currentIndex > 0);
        setnextButtonEnable(currentIndex < items.length - 1);
    }, [currentIndex, items, onRecipientChange]);
  
    const handlePrevious = () => {
      setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : items.length - 1));
    };
  
    const handleNext = () => {
      setCurrentIndex((prevIndex) => (prevIndex < items.length - 1 ? prevIndex + 1 : 0));
    };
    return (
      <div className="d-flex mb-4" style={{borderBottom:"black solid 2px"}}>
            <h1> 
            {items.length > 0 ? <>{items[currentIndex].ContactName}, {items[currentIndex].BusinessEmail}</> : <>No Recipient Selected</>}
            </h1> 
        <div className="d-flex justify-content-end ms-auto gap-2">
          <button className="p-sm-btn" onClick={handlePrevious} disabled={!prevButtonEnable}><i class="fa-solid fa-chevron-left"></i></button>
          <button className="p-sm-btn" onClick={handleNext} disabled={!nextButtonEnable}><i class="fa-solid fa-chevron-right"></i></button>
        </div>
        
      </div>
    );
};